/**
 * @AwsApi
 * - static class for direct AWS communication from the front end using the aws sdk for javascript 
 *   (see script tag in index.php for version)
 * 
 * 
 ************************* Methods *******************************

* ? setupS3Client takes no parameters and returns a promise
 - setupS3Client.then( () => call_other_aws_api_methods_here );
-- MUST be called before any other method (unless @JUNOFileUpload is being used)
-- validates and configures the aws sdk irt
-- use in connection with @JUNOFileUpload for the best upload experience


* ? uploadObjectToS3 takes a parameter of type AwsApiObject and returns an upload_abort_hook
 - let upload_abort_hook = uploadObjectToS3(updateParams: AwsApiObject);
 -- to abort: upload_abort_hook();
 -- use in connection with @JUNOFileUpload for the best upload experience


 * 
 */
export interface AwsApiS3Client {
  bucket: string;
  folder: string;
  identity: string;
  region: string;
}

export interface AwsApiObject {
  upload_object: File;
  object_name: string;
  metadata: AwsApiFileMetadataObject;
  progress_callback: Function;
  done_callback: Function;
}

// All metadata attached to a file must be a string
export interface AwsApiFileMetadataObject {
  base_url: string; //CrowdHub_App.CONFIG.BASE_URL
  content_id: string; //contentId.toString(),
  platform: string; //JSON.stringify(window.PLATFORM_DATA),
  user_id: string; //App.INSTANCE.CurrentUser.Id.toString(),
}

export default class AwsApi {
  private static _uploadBucket: string;
  private static _uploadFolder: string;
  private static _uploadRegion = 'us-east-1';
  private static _s3: Aws.S3;
  private static _identityPoolId: string;

  public static handleApiCallToJuno(aUrl, aVars): Promise<{}> {
    return new Promise<string>((resolve, reject) => {
      App.INSTANCE.mApi.Request(
        CrowdHub_App.CONFIG.BASE_URL + aUrl,
        aVars,
        successResponse => {
          console.log('+++handleApiCallToJuno: AWS Api Success!' + JSON.stringify(successResponse));

          resolve(successResponse);
        },
        errorResponse => {
          console.error('+++handleApiCallToJuno: AWS Api Error: ' + JSON.stringify(errorResponse));
          reject(errorResponse);
        },
      );
    });
  }

  public static updateJunoDbWithFileData(aVars): void {
    let url = 'custom_api/api_Services_AWS.php';

    aVars.api = 'api_upload_file_info';
    aVars.user_id = App.INSTANCE.CurrentUser.Id;

    this.handleApiCallToJuno(url, aVars);
  }

  public static setupS3Client(use_platform_bucket = false): Promise<string> {
    let url = 'custom_api/api_Services_AWS.php';
    let vars = {
      api: 'api_aws_get_client_configuration',
      user_id: App.INSTANCE.CurrentUser.Id,
      use_platform_bucket: use_platform_bucket,
    };
    return new Promise<string>((resolve, reject) => {
      this.handleApiCallToJuno(url, vars).then(response => {
        let results = response.results;
        this.updateS3Client(results);
        resolve(results);
      });
    });
  }

  // public static getPresignedRequestUrl(): Promise<string> {
  //     return new Promise((resolve, reject) => {
  //         let aUrl = 'custom_api/api_Services_AWS.php';
  //         let vars = {
  //             api: 'api_aws_get_presigned_request_url',
  //             user_id: App.INSTANCE.CurrentUser.Id,
  //         };
  //         App.INSTANCE.mApi.Request(
  //             CrowdHub_App.CONFIG.BASE_URL + aUrl,
  //             vars,
  //             successResponse => {
  //                 if (successResponse.success == true) {
  //                     console.log(
  //                         'AWS Api Success!' +
  //                             JSON.stringify(successResponse),
  //                     );
  //                     let results = successResponse.results;
  //                     resolve(results.url);
  //                 } else {
  //                     console.error(
  //                         'AWS Api Error: ' + JSON.stringify(successResponse),
  //                     );
  //                     reject(successResponse);
  //                 }
  //             },
  //             errorResponse => {
  //                 console.error(
  //                     'AWS Api Error: ' + JSON.stringify(errorResponse),
  //                 );
  //                 reject(errorResponse);
  //             },
  //         );
  //     });
  // }

  public static updateS3Client(updateParams: AwsApiS3Client) {
    this._uploadBucket = updateParams.bucket;
    this._uploadFolder = updateParams.folder;
    this._identityPoolId = updateParams.identity;
    this._uploadRegion = updateParams.region;

    AWS.config.update({
      region: this._uploadRegion,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: this._identityPoolId,
      }),
    });

    this._s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      params: { Bucket: this._uploadBucket },
    });
  }

  public static setS3Bucket(bucketName: string) {
    this._uploadBucket = bucketName;
  }

  public static getS3Bucket(): string {
    return this._uploadBucket;
  }

  public static setS3Folder(folderName: string) {
    this._uploadFolder = folderName;
  }

  public static getS3Folder(): string {
    return this._uploadFolder;
  }

  public static uploadObjectToS3(uploadParams: AwsApiObject): Function {
    if (!uploadParams.object_name) {
      uploadParams.object_name = uploadParams.upload_object.name;
    }
    var upload = this._s3.upload({
      Bucket: this._uploadBucket,
      Key: `${this._uploadFolder ? this._uploadFolder + '/' : ''}${uploadParams.object_name}`,
      Body: uploadParams.upload_object,
      ACL: 'public-read',
      Metadata: uploadParams.metadata,
    });

    upload
      .on('httpUploadProgress', function (progress) {
        let uProgress = (progress.loaded * 100) / progress.total;
        let uploaded = parseInt(uProgress.toString());
        if (typeof uploadParams.progress_callback === 'function') {
          uploadParams.progress_callback(uploaded);
        }
      })
      .send(function (err, data) {
        if (err) {
          console.error('Error:', err.code, err.message);
          if (typeof uploadParams.progress_callback === 'function') {
            uploadParams.done_callback(err, data);
          }
        } else {
          if (typeof uploadParams.progress_callback === 'function') {
            uploadParams.done_callback(null, data);
          }
          console.log(data);
        }
      });

    return () => {
      upload.abort();
    };
  }
}
